import { routesBuilder } from '@guiker/shared-framework'

import { Portfolio } from '../../../../../entity'
import { paths } from '../../../paths'

const { buildGet } = routesBuilder<Portfolio>()({
  basePath: paths.investorProfiles.withId.portfolio.path,
})

export const routes = {
  readAllInvestorProfilePortfolio: buildGet(),
}
